import { MessageSquare } from 'lucide-react';
import { cn } from '@/lib/cn';

interface LauncherProps {
  unreadCount: number;
  onClick: () => void;
  /** Accessible name; the care-team messaging drawer uses "Messages". */
  label?: string;
}

export function Launcher({ unreadCount, onClick, label = 'Support chat' }: LauncherProps) {
  return (
    <button
      type="button"
      aria-label={unreadCount > 0 ? `${label} (${unreadCount} unread)` : label}
      onClick={onClick}
      data-tour="support-button"
      // style={{ borderRadius: '50%' }}
      className={cn(
        'fixed z-helpdock flex items-center justify-center',
        'w-40 h-40 bg-black text-white',
        'hover:bg-[#252525] active:bg-black',
        // 'transition-colors duration-fast',
        // Mobile: sit above the bottom nav (h-50) with 10px gap
        'bottom-60 right-15',
        // Desktop: hug the corner
        'md:bottom-20',
      )}
    >
      <MessageSquare size={22} strokeWidth={1.5} />
      {unreadCount > 0 && (
        <span
          aria-hidden
          className="absolute -top-4 -right-4 min-w-18 h-18 flex items-center justify-center bg-accent text-white text-10 leading-100 px-4"
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
